import { render, staticRenderFns } from "./YoureWatching.vue?vue&type=template&id=8fc43490&scoped=true&"
import script from "./YoureWatching.vue?vue&type=script&lang=js&"
export * from "./YoureWatching.vue?vue&type=script&lang=js&"
import style0 from "./YoureWatching.vue?vue&type=style&index=0&id=8fc43490&prod&lang=css&"
import style1 from "./YoureWatching.vue?vue&type=style&index=1&id=8fc43490&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc43490",
  null
  
)

export default component.exports